/**
 * Product navigation — Dashboard first; deep pages under «Ещё».
 * Paths must match HistoryRouter / DashboardShell tabs.
 * Host filters via hostSite.tabAllowedOnSite (paper.* hides Live, live.* is slim).
 */
import { LIVE_SECTION_ENABLED, LIVE_GRADUATION_TOOLTIP } from '../mode.js'
import { SITE_MODE, tabAllowedOnSite } from './hostSite.js'

export const NAV_GROUPS_ALL = [
  {
    id: 'main',
    title: '',
    items: [
      { id: 'overview', path: '/dashboard/overview', title: 'Дашборд', hint: '' },
      { id: 'trades', path: '/dashboard/trades', title: 'Ставки', hint: '' },
      { id: 'brain', path: '/dashboard/brain', title: 'Мозг', hint: '' },
      {
        id: 'live',
        path: '/dashboard/live',
        title: 'Живая торговля',
        hint: LIVE_SECTION_ENABLED ? '15m · pUSD' : 'Скоро',
      },
    ],
  },
  {
    id: 'more',
    title: 'Ещё',
    items: [
      { id: 'diagnostics', path: '/dashboard/diagnostics', title: 'Диагностика', hint: '' },
      { id: 'collect', path: '/dashboard/collect', title: 'Сбор', hint: '' },
      { id: 'ops', path: '/dashboard/ops', title: 'Управление', hint: '' },
      { id: 'client', path: '/dashboard/client', title: 'Клиент', hint: 'Mini App друга' },
      { id: 'logs', path: '/dashboard/logs', title: 'Логи', hint: '' },
      // Sessions → hub Settings (dashboard.*); kept here for local SPA testing only.
      { id: 'sessions', path: '/dashboard/sessions', title: 'Сессии', hint: '' },
    ],
  },
]

/** Nav groups filtered for the current host (paper / live / local). */
export const NAV_GROUPS = NAV_GROUPS_ALL.map((g) => ({
  ...g,
  items: g.items.filter((t) => tabAllowedOnSite(t.id, SITE_MODE)),
})).filter((g) => g.items.length > 0)

export const NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items)

/** @deprecated Live is a real nav item now — kept for older imports */
export const LIVE_NAV = {
  id: 'live',
  path: '/dashboard/live',
  title: 'Живая торговля',
  disabled: !LIVE_SECTION_ENABLED,
  tooltip: LIVE_GRADUATION_TOOLTIP,
}

const COLLAPSE_KEY = 'pmhub.nav.collapsed'

export function readNavCollapsed() {
  try {
    return localStorage.getItem(COLLAPSE_KEY) === '1'
  } catch {
    return false
  }
}

export function writeNavCollapsed(collapsed) {
  try {
    localStorage.setItem(COLLAPSE_KEY, collapsed ? '1' : '0')
  } catch {
    /* ignore */
  }
}

export function tabFromPath(pathname) {
  const p = pathname || ''
  const hit = NAV_ITEMS.find((t) => p === t.path || p.startsWith(t.path + '/'))
  if (hit) return hit.id
  if (SITE_MODE === 'live') return 'live'
  return 'overview'
}

/** Telegram id from /dashboard/client/:id — 0 on the compact index. */
export function clientTelegramIdFromPath(pathname) {
  const m = String(pathname || '').match(/^\/dashboard\/client\/(\d+)\/?$/)
  if (!m) return 0
  const n = Number(m[1])
  return Number.isFinite(n) && n > 0 ? n : 0
}
